import { executeStandardRequest } from '@musinsa/packages-http';
import { publicHttpClient } from '../httpClient';
import { accountInfoApiPath } from './apiPath';
import type { GetBanksResponse } from './types';

export const getBanks = () =>
  executeStandardRequest(() => publicHttpClient.get<GetBanksResponse>(accountInfoApiPath.getBanks));
